import { render, staticRenderFns } from "./CustomReportGenerationTypeField.vue?vue&type=template&id=b3aad8dc"
import script from "./CustomReportGenerationTypeField.vue?vue&type=script&lang=js"
export * from "./CustomReportGenerationTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports